import styled from 'styled-components';

const Container = styled.div<{ selected?: boolean }>`
	background: ${(props) => props.theme.colors.lightBlue};
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 12px;
	line-height: 24px;
	padding: 0px 8px;
	border-radius: 12px;

	${(props) =>
		props.selected &&
		`
        background: ${props.theme.colors.primary};
        color: white;
    `}
`;

export function Count(props: { count: number; selected?: boolean }) {
	return <Container selected={props.selected}>{props.count}</Container>;
}
